import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChTabsComponent } from './ch-tabs.component';
import { ChTabComponent } from './tab.component';
import { TabTitleDirective } from './tab-title.directive';
import { TabContentDirective } from './tab-content.directive';



export class ChTabsModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    ChTabsComponent,
    ChTabComponent,
    TabTitleDirective,
    TabContentDirective,
  ],
  exports: [
    ChTabsComponent,
    ChTabComponent,
    TabTitleDirective,
    TabContentDirective
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
